<div class="container my-3">
  <div *ngIf="!isUser">
    <div class="row mb-3">
      <div class="col-md-6">
        <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchQuery" (input)="search()"/>
      </div>

      <div class="col-md-6">
        <select class="form-select" [(ngModel)]="selectedJobTitle" (change)="filterByJobTitle()">
          <option value="">Todos os Cargos</option>
          <option *ngFor="let job of getUniqueJobTitles()" [value]="job">{{ job }}</option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="isUser">
    <div class="row mb-3">
      <div class="col-md-12">
        <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchQuery" (input)="search()"/>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-light">
      <tr>
        <th *ngFor="let header of headers">
          <ng-container *ngIf="header == headers[0] || header == headers[2]; else elseTemplate" hidden></ng-container>
          <ng-template #elseTemplate>
            {{ header }}
          </ng-template>
        </th>
        <th *ngIf="!isUser">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of paginatedData">
        <td *ngFor="let col of row; let i = index">
          <span *ngIf="i===0 || i===2; else elsePersonId" hidden>{{ col }}</span>
          <ng-template #elsePersonId>
            <span *ngIf="i!==5">{{ col }}</span>
            <span *ngIf="i==5 && col == 'CREATED'" class="badge bg-primary rounded-pill">CRIADA</span>
            <span *ngIf="i==5 && col == 'CANCELLED'" class="badge bg-danger rounded-pill">CANCELADA</span>
            <span *ngIf="i==5 && col == 'FINISHED'" class="badge bg-green rounded-pill">FINALIZADA</span>
          </ng-template>
        </td>
        <td *ngIf="!isUser">
          <button *ngIf="row[5] == 'CREATED'" class="btn me-1 btn-primary btn-sm" (click)="onFinish(row)">
            ✅Concluir
          </button>
          <button *ngIf="row[5] == 'CREATED'" class="btn btn-primary btn-sm" (click)="onEdit(row)">
            ✍️Editar
          </button>
          <button *ngIf="row[5] == 'CREATED'" class="btn btn-danger btn-sm mx-1" (click)="onDelete(row)">
            🗑️Cancelar
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <nav aria-label="Table pagination">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button class="page-link" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
          Anterior
        </button>
      </li>
      <li class="page-item" *ngFor="let page of [].constructor(totalPages); let i = index" [class.active]="i + 1 === currentPage">
        <button class="page-link" (click)="changePage(i + 1)">
          {{ i + 1 }}
        </button>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button class="page-link" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
          Próximo
        </button>
      </li>
    </ul>
  </nav>
</div>
